export const cols_1= [
  {
    title: "排名",
    key: "number",
    align: "center",
   
  }, 
  {
    title: "线组/车间",
    key: "thread",
    align: "center"
  },
  {
    title: "岗位",
    key: "post",
    align: "center"
  },
  {
    title: "标准工时 s",
    key: "standard",
    align: "center"
  },
  {
    title: "实际工时 s",
    key: "actual",
    align: "center"
  },
  {
    title: "效率",
    key: "efficiency",
    align: "center"
  }
  ]

  export const cols_2= [
    {
        title: "排名",
        width:"10vw",
        key: "ranking",
        align: "center",
        slot: "ranking"
      },
      {
        title: "图片",
        key: "img",
        align: "center",
        slot: "img"
      },
      {
        title: "货号",
        key: "goodsno",
        align: "center"
      },
      {
        title: "商品浏览量",
        key: "goods_browse",
        align: "center"
      },
      {
        title: "商品访客数",
        key: "goods_visitor",
        align: "center"
      },
      {
        title: "支付件数",
        key: "pay_number",
        align: "center"
      }
  ]